import { Outlet } from 'react-router';

import { ReportsRepositoryProvider } from './reports-repository-context';

// ----------------------------------------------------------------------

export function ReportsRepositoryLayout() {

  return (
    <ReportsRepositoryProvider>
      <Outlet />
    </ReportsRepositoryProvider>
  );
}
